import Box from '@mui/material/Box/Box'
import Divider from '@mui/material/Divider/Divider'
import Grid from '@mui/material/Grid/Grid'
import React, { useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { ReactComponent as RationEditLogo } from '../../assets/ration_edit_logo.svg'
import { IRationTableComponents } from '../../models/IRationSystem'
import { TypographyPrimary } from '../../ui/typography/TypographyPrimary'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'
import TooltipHover from '../../ui/TooltipHover'
import PopupRationEditComp from '../shared/PopupRationEditComp'

interface RationTableComponentsProps {
	rationComponents: IRationTableComponents[]
}

const RationTableComponent: React.FC<{
	component: IRationTableComponents
	permissions
}> = ({ component, permissions }) => {
	const [openEditComp, setOpenEditComp] = useState(false)
	const { userData } = useAppSelector(state => state.userReducer)
	return (
		<Grid
			key={component.id}
			container
			sx={{
				marginTop: '24px',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
			}}
		>
			<Grid item xs={4} sm={1} md={2} lg={2} xl={2} sx={{ paddingTop: '10px' }}>
				<TypographyPrimary>{component.title}</TypographyPrimary>
			</Grid>
			<Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{ paddingTop: '10px' }}>
				<TypographyPrimary>
					{component.dry_matter_percent + ' %'}
				</TypographyPrimary>
			</Grid>
			<Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						flexWrap: 'wrap',
						gap: '4px',
					}}
				>
					{component.ration_titles.map((title, index) => (
						<Box
							key={index}
							style={{
								minWidth: 'max-content',
								fontSize: '14px',
								fontWeight: '400',
								padding: '8px 16px',
								background: '#f7f7f7',
								borderRadius: '12px',
								whiteSpace: 'nowrap',
							}}
						>
							{title}
						</Box>
					))}
				</Box>
			</Grid>
			{permissions.can_edit_rations && !userData.company.food_integration && (
				<Grid
					item
					xs={12}
					sm={2}
					md={2}
					lg={2}
					xl={2}
					sx={{
						display: 'flex',
						justifyContent: 'flex-end',
						paddingTop: '6px',
					}}
				>
					<TooltipHover
						title='Редактирование компонента'
						placement='bottom'
						oneLine
						offset={[-16, 0]}
					>
						<RationEditLogo
							fill={COLORS.icon}
							style={{ cursor: 'pointer' }}
							width='18px'
							height='18px'
							onClick={() => setOpenEditComp(true)}
						/>
					</TooltipHover>
				</Grid>
			)}

			{openEditComp && (
				<PopupRationEditComp
					openEditComp={openEditComp}
					setOpenEditComp={setOpenEditComp}
					title={component.title}
					dry_matter_percent={component.dry_matter_percent}
					id={component.id}
				/>
			)}
		</Grid>
	)
}
const RationTableComponents: React.FC<RationTableComponentsProps> = ({
	rationComponents,
}) => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	return (
		<Box
			sx={{
				width: '100%',
				height: 'auto',
				backgroundColor: '#fff',
				borderRadius: '12px',
				padding: '28px 24px',
				marginTop: '16px',
			}}
		>
			<Grid
				container
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Grid item xs={4} sm={1} md={2} lg={2} xl={2}>
					<TypographySecondary>Компоненты</TypographySecondary>
				</Grid>
				<Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
					<TypographySecondary>СВ, %</TypographySecondary>
				</Grid>
				<Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
					<TypographySecondary>Используется в рационах</TypographySecondary>
				</Grid>
				{permissions.can_edit_rations && !userData.company.food_integration && (
					<Grid
						item
						xs={12}
						sm={2}
						md={2}
						lg={2}
						xl={2}
						sx={{ textAlign: 'right' }}
					>
						<TypographySecondary>Редактировать</TypographySecondary>
					</Grid>
				)}
			</Grid>
			<Divider sx={{ marginTop: '8px' }} />
			{rationComponents?.length === 0 ? (
				<Box
					sx={{
						marginTop: '30px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<TypographySecondary>
						Здесь появятся добавленные компоненты
					</TypographySecondary>
				</Box>
			) : (
				rationComponents?.map(el => (
					<RationTableComponent
						key={el.id}
						component={el}
						permissions={permissions}
					/>
				))
			)}
		</Box>
	)
}

export default RationTableComponents
